<script lang="ts" setup>
useAppearanceClass()
const { siteName } = useSite()

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | ${siteName.value}` : siteName.value
  },
})
</script>

<template>
  <FloatingConfigurator />

  <div class="blueprint-entry">
    <div class="blueprint-entry-card">
      <div class="entry-brand">
        <img class="sos-entry-logo" src="/images/sos-restoration.webp" alt="SOS Restoration" />
        <div>
          <small>Field operations</small><strong>Workspace access</strong>
        </div>
      </div>
      <NuxtPage />
    </div>
  </div>
  <Toast />
</template>
